module.exports = __webpack_public_path__ + "media/photo/telecom_man-d0b8172b.jpg";